module.exports = __webpack_public_path__ + "static/media/Sam-Valdivia_160px.019dfe90.jpg";